'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Tab = require('react-bootstrap/Tab');
var Tabs = require('react-bootstrap/Tabs');
var TabPanel_module = require('./TabPanel.module.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Tab__default = /*#__PURE__*/_interopDefaultLegacy(Tab);
var Tabs__default = /*#__PURE__*/_interopDefaultLegacy(Tabs);

class TabPanel extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            key: '0',
        };
        this.setStateAndHash = (key, tabsConfig) => {
            var _a;
            this.setState({ key });
            if ((_a = tabsConfig[Number(key)]) === null || _a === void 0 ? void 0 : _a.name) {
                window.location.hash = `tabs-${tabsConfig[Number(key)].name}`;
            }
        };
        this.handleSelect = (key, tabsConfig) => {
            this.setStateAndHash(key, tabsConfig);
        };
    }
    componentDidMount() {
        const { tabsConfig } = this.props;
        const { hash } = window.location;
        let key = '0';
        if (hash) {
            for (let i = 0; i < tabsConfig.length; i += 1) {
                if (hash.slice(6) === tabsConfig[i].name) {
                    key = i.toString();
                    break;
                }
            }
        }
        this.setStateAndHash(key, tabsConfig);
    }
    render() {
        const { id, tabsConfig } = this.props;
        const { key } = this.state;
        return (React__default["default"].createElement(Tabs__default["default"], { activeKey: key, onSelect: (k) => this.handleSelect(k, tabsConfig), className: TabPanel_module["default"].tabPanel, id: id, mountOnEnter: true, unmountOnExit: false, transition: false }, tabsConfig.map((c, i) => (React__default["default"].createElement(Tab__default["default"], { key: c.name, eventKey: `${i}`, title: c.name },
            React__default["default"].createElement("div", { className: TabPanel_module["default"].tab }, c.component && React__default["default"].createElement(c.component, c.props)))))));
    }
}
TabPanel.defaultProps = {
    id: 'TabPanel',
};

exports["default"] = TabPanel;
